// Indian currency + number formatters

export function formatIndianCurrency(value, opts = {}) {
  if (value === null || value === undefined || isNaN(value)) return "₹0";
  const v = Number(value);
  const abs = Math.abs(v);
  const sign = v < 0 ? "-" : "";
  if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(opts.decimals ?? 2)} Cr`;
  if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(opts.decimals ?? 2)} L`;
  if (abs >= 1000) return `${sign}₹${formatIndianGrouping(Math.round(abs))}`;
  return `${sign}₹${Math.round(abs)}`;
}

// Indian number grouping: 1,71,000 not 171,000
export function formatIndianGrouping(value) {
  if (value === null || value === undefined || isNaN(value)) return "0";
  const s = Math.round(Number(value)).toString();
  if (s.length <= 3) return s;
  const last3 = s.slice(-3);
  const rest = s.slice(0, -3);
  const grouped = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return `${grouped},${last3}`;
}

export function formatPct(v, opts = {}) {
  if (v === null || v === undefined || isNaN(v)) return "0%";
  const sign = opts.signed && v > 0 ? "+" : "";
  return `${sign}${Number(v).toFixed(opts.decimals ?? 1)}%`;
}

export function formatCompact(v) {
  if (v === null || v === undefined || isNaN(v)) return "0";
  const abs = Math.abs(v);
  if (abs >= 1e7) return `${(v / 1e7).toFixed(1)} Cr`;
  if (abs >= 1e5) return `${(v / 1e5).toFixed(1)} L`;
  if (abs >= 1000) return `${(v / 1000).toFixed(1)}K`;
  return formatIndianGrouping(v);
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false });
}
